module.exports = __webpack_public_path__ + "/img/7640ab424ca3548127cd17c621e3ff7c.png";